import { TemplateRef } from '@angular/core';
import {
  DataColumn,
  DataColumnDate,
} from '@app/shared/components/data-table/data-table';
import { SimpleModalInputBindings } from '@app/shared/components/modal/simple-modal/simple-modal.component';

import { RuleDeleteModalOptions } from '@app/business-rules/model';

export function makeColumns(templateRefs: {
  ruleNameTemplate: TemplateRef<any>;
  conditionsTemplate: TemplateRef<any>;
  actionsTemplate: TemplateRef<any>;
  ruleStatusTemplate: TemplateRef<any>;
  enabledStatusTemplate: TemplateRef<any>;
}): (DataColumn | DataColumnDate)[] {
  return [
    {
      label: 'Core_Name',
      canSort: true,
      sortName: 'ruleName',
      template: templateRefs.ruleNameTemplate,
      headClasses: 'l_w35',
    },
    {
      label: 'BusinessRules_Conditions_Column',
      canSort: false,
      template: templateRefs.conditionsTemplate,
      headClasses: 'l_w20',
    },
    {
      label: 'Core_Actions',
      canSort: false,
      template: templateRefs.actionsTemplate,
      headClasses: 'l_w20',
    },
    {
      label: 'BusinessRules_DateCreated_Column',
      canSort: true,
      sortName: 'createDate',
      dateFormat: 'shortDate',
      type: 'date',
      prop: 'createDate',
      headClasses: 'l_w15',
    },
    {
      label: 'Core_Status',
      canSort: false,
      template: templateRefs.ruleStatusTemplate,
      headClasses: 'l_w10',
    },
    {
      label: 'Core_Enabled',
      canSort: false,
      template: templateRefs.enabledStatusTemplate,
      headClasses: 'l_w10',
    },
  ];
}

export function makeSegmentColumns(templateRefs: {
  ruleNameTemplate: TemplateRef<any>;
  conditionsTemplate: TemplateRef<any>;
}): (DataColumn | DataColumnDate)[] {
  return [
    {
      label: 'BusinessRules_SegmentName',
      canSort: true,
      sortName: 'ruleName',
      headClasses: 'l_w35',
      bodyClasses: 'break',
      template: templateRefs.ruleNameTemplate,
    },
    {
      label: 'BusinessRules_Attributes_Column',
      canSort: false,
      headClasses: 'l_w35',
      bodyClasses: 'break',
      template: templateRefs.conditionsTemplate,
    },
    {
      label: 'BusinessRules_DateCreated_Column',
      canSort: true,
      headClasses: 'l_w20',
      sortName: 'createDate',
      dateFormat: 'shortDate',
      type: 'date',
      prop: 'createDate',
    },
  ];
}

export function makeInputBindings(
  options: RuleDeleteModalOptions
): SimpleModalInputBindings {
  return {
    canCancel: true,
    headerText: options.deleteText,
    submitButtonText: options.deleteText,
    bodyClasses: 'font-bold',
    bodyText: options.confirmationMessage,
  };
}
